/* PourOver Emb scroll motion (port of ColdGear cg-chapter.js reveal + mobile deck) */
(function () {
  if (window.__cncMotion) return; window.__cncMotion = true;
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = window.matchMedia('(max-width: 989px)');
  var isHome = document.body.classList.contains('template-index');
  var onPage = isHome || document.body.classList.contains('template-collection') || document.body.classList.contains('template-page') || document.body.classList.contains('template-product');

  function sections() { return Array.prototype.slice.call(document.querySelectorAll('main > .shopify-section, main .shopify-section')); }
  function tag() {
    var list = sections(); if (!list.length) return;
    var hasCg = !!document.querySelector('.cg-ch');
    list.forEach(function (s, i) {
      /* reveal: everything except the very first section (hero) and the product main section */
      var isMain = /__main$/.test(s.id);
      var isCg = !!s.querySelector(':scope > .cg-ch, :scope > .cg-footer');
      if (i > 0 && !isMain && !isCg && !s.classList.contains('cnc-rv')) s.classList.add('cnc-rv');
      /* deck: homepage only */
      if (isHome) {
        if (hasCg) { s.classList.add('cg-section'); if (i === list.length - 1) s.classList.add('cg-section--static'); }
        else { s.classList.add('cnc-deck'); if (i === list.length - 1) s.classList.add('cnc-deck--static'); }
      }
    });
  }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -12% 0px' }) : null;
  function scan() {
    document.querySelectorAll('main .shopify-section.cnc-rv:not(.is-in)').forEach(function (el) {
      /* already on screen at load → show at once */
      var r = el.getBoundingClientRect();
      if (!io || r.top < window.innerHeight * 0.88) { el.classList.add('is-in'); return; }
      io.observe(el);
    });
  }
  function deck() {
    if (!isHome) return;
    var cg = !!document.querySelector('.cg-ch');
    var sel = cg ? 'main .shopify-section.cg-section:not(.cg-section--static)' : 'main .shopify-section.cnc-deck:not(.cnc-deck--static)';
    var prop = cg ? '--cg-deck-top' : '--cnc-deck-top';
    var vh = window.innerHeight;
    document.querySelectorAll(sel).forEach(function (s) {
      if (!mobile.matches) { s.style.removeProperty(prop); return; }
      s.style.setProperty(prop, Math.min(0, vh - s.offsetHeight) + 'px');
    });
  }
  var queued = false;
  function queueDeck() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; deck(); }); }
  function boot() {
    if (!onPage || reduce) return;
    tag(); root.classList.add('cnc-motion'); scan(); deck();
    if ('ResizeObserver' in window) { var ro = new ResizeObserver(queueDeck); document.querySelectorAll('main .shopify-section').forEach(function (s) { ro.observe(s); }); }
    setTimeout(queueDeck, 600); setTimeout(queueDeck, 2000);
    window.addEventListener('resize', queueDeck); window.addEventListener('load', queueDeck);
    if (mobile.addEventListener) mobile.addEventListener('change', queueDeck);
    document.addEventListener('shopify:section:load', function () { tag(); scan(); queueDeck(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* hide the product sticky add-to-cart while the footer is on screen (phones) */
(function(){
  var bar = document.querySelector('sticky-atc, .sticky-atc'); var foot = document.querySelector('.cg-footer, footer');
  if(!bar || !foot || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(function(es){ es.forEach(function(e){ bar.classList.toggle('is-footer', e.isIntersecting); }); }, { rootMargin: '0px 0px -40px 0px' }).observe(foot);
})();
